var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    ref: "bundleId_field",
    attrs: {
      value: _vm.value,
      rules: _vm.rules,
      items: _vm.items,
      loading: _vm.loading,
      "item-text": "name",
      "item-value": "id",
      "menu-props": { contentClass: "grv-menu" },
      "search-input": _vm.search,
      readonly: _vm.readonly,
      multiple: _vm.multiple,
      "auto-select-first": "",
      dense: "",
      "no-filter": "",
      "hide-no-data": "",
      "small-chips": "",
      "deletable-chips": "",
      placeholder: "Rechercher un Bundle",
      hint: _vm.hint
    },
    on: {
      change: function($event) {
        return _vm.emitChange($event)
      },
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "label",
        fn: function() {
          return [
            _vm.param
              ? _c("span", [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm._f("maestroParamLabel")(_vm.param)) +
                      "\n\t\t"
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "item",
        fn: function(data) {
          return [
            _c(
              "v-list-tile-avatar",
              [
                _c(
                  "v-chip",
                  {
                    staticClass: "ma-0 font-weight-bold",
                    attrs: { label: "", small: "", color: "white color--text" }
                  },
                  [_vm._v("\n\t\t\t\t#" + _vm._s(data.item.id) + "\n\t\t\t")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-list-tile-content",
              [
                _c("v-list-tile-title", [
                  _vm._v("\n\t\t\t\t" + _vm._s(data.item.name) + "\n\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "v-list-tile-sub-title",
                  { staticClass: "font-italic caption" },
                  [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(data.item.description) + "\n\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-419b5593", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-419b5593","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/field_bundle_id.vue
// module id = null
// module chunks = 